import BaseItem from './../../MyLeaves/Item';
import LeaveRules from '../../../LeaveRules';

export default class Item extends BaseItem {
    canBeCanceled(leave: any) {
        return LeaveRules.canBeCanceled(leave, (this.getSession().getState() as any).companyUser);
    }
}